import { lcSideFilterFragment } from 'humanity/components/lcSideFilter';
import { lcTextCardFragment } from 'humanity/components/lcTextCard';
import { lcTopFilterFragment } from 'humanity/components/lcTopFilter';
import { lcMastheadFragment } from 'humanity/sections/lcMasthead';

/**
 * @type {String}
 */
export const learningCenterPageFragment = `
  ... on PageContentLearningCenterPage {
    sys {
      id
    }
    internalTitle
    sectionsCollection(limit: 15) {
      items {
        __typename
        ${lcMastheadFragment}
        ${lcTopFilterFragment}
        ${lcSideFilterFragment}
        ${lcTextCardFragment}
      }
    }
  }
`;
